module.exports = __webpack_public_path__ + "img/Memberkit-3-pt.44e80a02.png";